/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, totalPages: NonNullable<unknown> }} Moderationpageindicator2Inputs */

const en_moderationpageindicator2 = /** @type {(inputs: Moderationpageindicator2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.totalPages}`)
};

const de_moderationpageindicator2 = /** @type {(inputs: Moderationpageindicator2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.totalPages}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {totalPages}" |
*
* @param {Moderationpageindicator2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationpageindicator2 = /** @type {((inputs: Moderationpageindicator2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationpageindicator2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationpageindicator2(inputs)
	return de_moderationpageindicator2(inputs)
});
export { moderationpageindicator2 as "moderationPageIndicator" }